export const sum = (arr: number[]): number => {
  return arr.reduce((sum, x) => sum + x, 0);
};
